import { createFileRoute } from "@tanstack/react-router";
import { NotFoundView } from "../../components/states.tsx";

/**
 * Any address under a company that no screen answers: the "page isn't here" page inside the shell, so the nav, ⌘K and
 * the way home stay where they always are. Signed out, the layout sends the person to sign in first, then back here.
 */
export const Route = createFileRoute("/_app/$")({
  component: () => <NotFoundView inShell />,
});
